export default __webpack_public_path__ + "static/media/artists.c18aacb3.svg";